import { Alert } from 'antd';
import useModalControls from 'hooks/useModalControls';
import ThirdPartyEmailModal from './Recoveries/ThirdPartyEmailModal';
import ManagedByThirdPartyAlert from './Recoveries/ManagedByThirdPartyAlert';
import ThirdPartyInfoPromptAlert from './Recoveries/ThirdPartyInfoPromptAlert';

const ThirdPartyAlerts = ({ thirdParty, hidePrompt }) => {
  const thirdPartyEmailModal = useModalControls();
  const hasThirdParty = thirdParty?.email || thirdParty?.name;

  return (
    <>
      {!thirdParty?.loading && (
        <>
          {thirdParty?.error && (
            <Alert
              banner
              type="error"
              title="Failed to retrieve 3rd party info."
              style={{ marginBottom: 'var(--spacing-md)' }}
            />
          )}
          {hasThirdParty ? (
            <ManagedByThirdPartyAlert
              showThirdPartyEmailModal={thirdPartyEmailModal.show}
              name={thirdParty?.name}
            />
          ) : (
            !hidePrompt && (
              <ThirdPartyInfoPromptAlert
                showThirdPartyEmailModal={thirdPartyEmailModal.show}
              />
            )
          )}
        </>
      )}
      <ThirdPartyEmailModal {...thirdPartyEmailModal} thirdParty={thirdParty} />
    </>
  );
};

export default ThirdPartyAlerts;
